/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AutoEmailTaskCreateBodyDoc } from './autoEmailTaskCreateBodyDoc';
import type { AutoEmailTaskCreatePriority } from './autoEmailTaskCreatePriority';
import type { AutoEmailTaskCreateSubjectDoc } from './autoEmailTaskCreateSubjectDoc';
import type { AutoEmailTaskCreateTaskNoteDoc } from './autoEmailTaskCreateTaskNoteDoc';
import type { AutoEmailTaskCreateThreadMode } from './autoEmailTaskCreateThreadMode';

/**
 * Sequence-driven email task. Created by the enrollment workflow.
 *
 * The fields below mirror the workflow's input — once the workflow
 * spawns the row, the user-facing surface is read-only (a "Send now"
 * button just fires the workflow earlier; nothing here is editable
 * after the fact).
 */
export interface AutoEmailTaskCreate {
  job_id: string;
  candidate_id: string;
  assignee_user_id: string;
  due_at?: string | null;
  priority?: AutoEmailTaskCreatePriority;
  title?: string | null;
  type: 'auto_email';
  mailbox_id?: string | null;
  to_email?: string | null;
  /** @maxLength 998 */
  subject?: string;
  subject_doc?: AutoEmailTaskCreateSubjectDoc;
  body_doc: AutoEmailTaskCreateBodyDoc;
  thread_mode?: AutoEmailTaskCreateThreadMode;
  /** @maxItems 20 */
  cc?: string[];
  /** @maxItems 20 */
  bcc?: string[];
  include_sender_signature?: boolean;
  include_unsubscribe_link?: boolean;
  task_note_doc?: AutoEmailTaskCreateTaskNoteDoc;
  enrollment_id: string;
  step_id: string;
  sequence_id: string;
  step_set_id: string;
}
